require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-neusiedl-illmitz.json") })
        }
      }, "path---betreuungseinrichtungen-neusiedl-illmitz");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-neusiedl-illmitz!./.cache/json/betreuungseinrichtungen-neusiedl-illmitz.json
// module id = 952
// module chunks = 231608221292675